import type { AlertContent, AlertVariant } from "./order-alert.types";

export const SESSION_STORAGE_KEY = "order-alert-dismissed";

export const ALERT_TIMING = {
  NOT_LAUNCHED: 0,
  EDUCATIONAL_PERIOD_DAYS: 30,
  KNOWLEDGE_PERIOD_DAYS: 60,
} as const;

const ORDERS_BASE_URL =
  import.meta.env.VITE_NEW_WOBA_ORDERS_URL?.trim() ||
  "https://woba-orders.woba.com.br/";

const getOrdersUrl = (path: string = "") => {
  if (!path) {
    return ORDERS_BASE_URL;
  }
  const normalizedPath = path.startsWith("/") ? path.slice(1) : path;
  return `${ORDERS_BASE_URL.replace(/\/$/, "")}/${normalizedPath}`;
};

const SHARED_CREATE_EDIT_CONTENT: Omit<
  AlertContent,
  "showSecondButton" | "showExtraInfo"
> = {
  title:
    "Vai criar uma proposta customizada? Agora temos um fluxo só pra isso!",
  description:
    "Para manter nosso inventário organizado, propostas customizadas foram separados da criação de salas privativas. Aqui você cadastra apenas salas privativas.",
  firstButtonText: "Criar proposta customizada",
  firstButtonLink: getOrdersUrl("orders/new"),
  bgColor: "bg-[#E8F0FB] border-[#9CADD9]",
};

export const ALERT_CONTENT: Record<AlertVariant, AlertContent> = {
  list: {
    title: "Procurando propostas customizadas? Elas mudaram de lugar",
    description:
      "Essa tela mostra apenas salas privativas. Para ver suas propostas customizadas, acesse a área dedicada que criamos.",
    firstButtonText: "Ver propostas customizadas",
    firstButtonLink: getOrdersUrl("dashboard"),
    secondButtonText: "Criar nova proposta customizada",
    secondButtonLink: getOrdersUrl("orders/new"),
    showSecondButton: true,
    showExtraInfo: true,
    bgColor: "bg-[#F5F5DC] border-[#D4C5A0]",
  },
  create: {
    ...SHARED_CREATE_EDIT_CONTENT,
    showSecondButton: false,
    showExtraInfo: true,
  },
  edit: {
    ...SHARED_CREATE_EDIT_CONTENT,
    showSecondButton: false,
    showExtraInfo: false,
  },
  vision: {
    title: "Procurando propostas customizadas? Elas mudaram de lugar",
    description:
      "Essa tela mostra apenas salas privativas. Para ver suas propostas customizadas, acesse a área dedicada que criamos.",
    firstButtonText: "Ver propostas customizadas",
    firstButtonLink: getOrdersUrl("dashboard"),
    showSecondButton: false,
    showExtraInfo: true,
    bgColor: "bg-[#F5F0E9] border-[#EBE4D8]",
  },
};
